// ** React Imports
import { useState, createContext, useEffect } from 'react'

// ** Intl Provider Import
import { IntlProvider } from 'react-intl'

// ** Core Language Data
import messagesEn from '@assets/data/locales/en.json'
import messagesTa from '@assets/data/locales/ta.json'
import messagesKa from '@assets/data/locales/ka.json'
import messagesHi from '@assets/data/locales/hi.json'

// ** User Language Data
import userMessagesEn from '@src/assets/data/locales/en.json'
import userMessagesDe from '@src/assets/data/locales/de.json'
import userMessagesFr from '@src/assets/data/locales/fr.json'
import userMessagesPt from '@src/assets/data/locales/pt.json'
import { useDispatch } from 'react-redux'

// ** Menu msg obj
const menuMessages = {
  en: { ...messagesEn, ...userMessagesEn },
  ta: { ...messagesTa, ...userMessagesDe },
  ka: { ...messagesKa, ...userMessagesFr },
  hi: { ...messagesHi, ...userMessagesPt }
}

// ** Create Context
const Context = createContext()

const IntlProviderWrapper = ({ children }) => {
  // ** States
  const [locale, setLocale] = useState('en')
  const [messages, setMessages] = useState(menuMessages['en'])

  // ** Switches Language
  const switchLanguage = lang => {
    setLocale(lang)
    setMessages(menuMessages[lang])
  }
  
  const dispatch = useDispatch()
  useEffect(() => {
    dispatch({type:"SET_LANG_DATA", payload:messages})
  }, [messages])

  return (
    <Context.Provider value={{ locale, switchLanguage, messages }}>
      <IntlProvider key={locale} locale={locale} messages={messages} defaultLocale='en'>
        {children}
      </IntlProvider>
    </Context.Provider>
  )
}

export { IntlProviderWrapper, Context as IntlContext }
